import React from 'react';
import './ErrorPage.css';
const ErrorPage = () => {
	return (
		<div className='error-div'>
			<section className='error-container'>
				<span>
					<span>4</span>
				</span>
				<span>0</span>
				<span>
					<span>4</span>
				</span>
			</section>
			<div className='link-container'>
				<a href='/' className='more-link'>
					Visit Home Page
				</a>
			</div>
		</div>
	);
};

export default ErrorPage;
